import * as actionTypes from './actionTypes';

const initialState = {
  editingUserId: null,
  editingUserIsLoading: false,
  ids: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.FETCH:
      return {
        ...state,
        editingUserIsLoading: true,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        editingUserIsLoading: false,
      };
    case actionTypes.SET_EDITING_USER_ID:
      return {
        ...state,
        editingUserId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.user.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.id),
        editingUserId: action.id === state.editingUserId ? null : state.editingUserId,
      };
    default:
      return state;
  }
};
